import { render, staticRenderFns } from "./aiChronicle.vue?vue&type=template&id=1b2345c8&scoped=true"
import script from "./aiChronicle.vue?vue&type=script&lang=js"
export * from "./aiChronicle.vue?vue&type=script&lang=js"
import style0 from "./aiChronicle.vue?vue&type=style&index=0&id=1b2345c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2345c8",
  null
  
)

export default component.exports